import type { GuidedStage } from './guidedBuilder.types'

export const guidedStages: readonly GuidedStage[] = [
  'deployment',
  'brand',
  'products',
  'knowledge',
  'rules',
  'behavior',
  'design',
  'review',
]

export const guidedStageLabels: Record<GuidedStage, string> = {
  deployment: 'Deployment',
  brand: 'Brand',
  products: 'Products',
  knowledge: 'Knowledge',
  rules: 'Rules',
  behavior: 'Behavior',
  design: 'Design',
  review: 'Review',
}

export function isGuidedStage(value: unknown): value is GuidedStage {
  return (
    typeof value === 'string' && guidedStages.some((stage) => stage === value)
  )
}

export function nextGuidedStage(stage: GuidedStage): GuidedStage {
  const currentIndex = guidedStages.indexOf(stage)

  return guidedStages[currentIndex + 1] ?? 'review'
}
